import { render } from "./SummaryDetailsScreen.vue?vue&type=template&id=8ea30e6a&scoped=true"
import script from "./SummaryDetailsScreen.vue?vue&type=script&lang=js"
export * from "./SummaryDetailsScreen.vue?vue&type=script&lang=js"

import "./SummaryDetailsScreen.vue?vue&type=style&index=0&id=8ea30e6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea30e6a"]])

export default __exports__